import React, { useState } from "react";
import FindInPageIcon from '@material-ui/icons/FindInPage';
import FullDocManager from "./FullDocManager";
import GQPopup from "../../shared/components/GQPopups/GQPopup";


function DocManagerLink(props){;

    const [docMangerIsOpen, setDocMangerIsOpen] = useState(false)

    const {ftWindowsToOpen, setFtWindowsToOpen, updateKWs} = props

    // useEffect(()=>{
    //     if(ftWindowsToOpen !== null && ftWindowsToOpen !== undefined && setFtWindowsToOpen !== null && setFtWindowsToOpen !== undefined){
    //         if(myWindow !== null){
    //             if(!myWindow.closed){
    //                 myWindow.postMessage(ftWindowsToOpen, window.location.href);
    //                 setFtWindowsToOpen(null)
    //                 return;
    //             }
    //         }
            
    //         let popup = openManager()
    //         popup.onload = () =>{
    //             popup.postMessage(ftWindowsToOpen, window.location.href);
    //             setFtWindowsToOpen(null)
    //         }
            
            
    //     }

    // },[ftWindowsToOpen])

    const openManager = () => {
        setDocMangerIsOpen(true)
    }

    const closeManager = () => {
        setDocMangerIsOpen(false)
    }

    return (
        <>
    
        <div onClick={()=>openManager()} style={{cursor: "pointer"}}>
            <FindInPageIcon style={{width: "20px", margin: "0 5px", paddingBottom: "4px"}}/><span>Text Document Manager</span>
        </div>
        <GQPopup
            show={docMangerIsOpen}
            mountMode="keepMounted"
            close={() => closeManager()}
            innerHtml={
                <FullDocManager
                    closeManager={() => closeManager()}
                    ftWindowsToOpen={ftWindowsToOpen}
                    setFtWindowsToOpen={(value) => { setFtWindowsToOpen(value); }}
                    updateKWs={updateKWs}
                />
            }
        />
      
        </> 
    );
}

export default DocManagerLink;